<div
  class="modal fade"
  id="vendedorModal"
  tabindex="-1"
  aria-labelledby="vendedorModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="vendedorModalLabel">
          {{ modoEditar ? "Editar Vendedor" : "Nuevo Vendedor" }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="guardarVendedor()">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="nombre" class="form-label">Nombre</label>
              <input
                type="text"
                class="form-control"
                id="nombre"
                [(ngModel)]="vendedor.nombre"
                name="nombre"
                required
                [ngClass]="{ 'is-invalid': errores['nombre'] }"
              />
              <div *ngIf="errores['nombre']" class="invalid-feedback">
                {{ errores["nombre"] }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label for="apellido" class="form-label">Apellido</label>
              <input
                type="text"
                class="form-control"
                id="apellido"
                [(ngModel)]="vendedor.apellido"
                name="apellido"
                required
                [ngClass]="{ 'is-invalid': errores['apellido'] }"
              />
              <div *ngIf="errores['apellido']" class="invalid-feedback">
                {{ errores["apellido"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="canalVenta" class="form-label">Canal de Venta</label>
              <select
                class="form-select"
                id="canalVenta"
                [(ngModel)]="vendedor.canalVenta"
                name="canalVenta"
                required
                [ngClass]="{ 'is-invalid': errores['canalVenta'] }"
              >
                <option value="" disabled selected>Seleccione un canal</option>
                <option value="CALL CENTER">CALL CENTER</option>
                <option value="STAFF">STAFF</option>
                <option value="EXTERNO">EXTERNO</option>
              </select>
              <div *ngIf="errores['canalVenta']" class="invalid-feedback">
                {{ errores["canalVenta"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3 d-flex align-items-end">
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="activo"
                  [(ngModel)]="vendedor.activo"
                  name="activo"
                />
                <label class="form-check-label" for="activo">Activo</label>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-3">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="cerrarModalVendedor()"
            >
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary">
              {{ modoEditar ? "Actualizar" : "Guardar" }} Vendedor
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
